module.exports = __webpack_public_path__ + "img/cateicon5.c962ff67.svg";